import {
  AccordionSummary,
  accordionSummaryClasses,
  Box,
  styled,
} from '@mui/material';

export const NCICHistoryList = styled(Box)(() => ({
  flex: 1,
  height: '100%',
}));
export const NCICHistoryDetails = styled(Box)(({ theme }) => ({
  flex: 1,
  height: '100%',
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(1),
}));
export const StyledAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
  flexDirection: 'row-reverse',
  gap: theme.spacing(2),
  [`&.${accordionSummaryClasses.expanded}`]: {
    backgroundColor: 'rgba(238, 62, 92, 0.4)',
  },
}));
